/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            var modalId = 'modal-' + nb.getSeq();
            this.set('modalId', modalId);
            nb.model.onChange('switchLanguage',function (inEvent,inKey) {
                var initData = this.setData();
                if(initData && typeof initData === 'object'){
                    this.setOpts(initData[inKey]);
                }
            },this);
        },
        setData:function (inData) {
            return inData;
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/Modal.js
// module id = 19
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 32 34 35 36